import ApiService from '@/services/core/api.service'

const DistributionService = {
  async get (query) {
    return ApiService.get(`admin/distributions?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/distributions', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/distributions/${payload.id}`, payload)
  }
}

export default DistributionService
